import React, {useEffect, useRef, useState} from "react";

import "./index.scss";

export default function SearchComponent({
  onSearch,
  searchTerm,
  placeholder = "Placeholder",
  id,
}) {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [searchTerm]);

    const handleChange = (event) => {
      onSearch(event.target.value);
    };

  return (
    <div className="search">
      <img src="/assets/icons/search.svg" alt="search" />
      <input
        type="text"
        ref={inputRef}
        value={searchTerm}
        onChange={handleChange}
        placeholder={placeholder}
        id={id}
      />
    </div>
  );
}
